if (!customElements.get('blog-article-search')) {
  class BlogArticleSearch extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.controller = null;
    }

    connectedCallback() {
      this.input = this.querySelector('[data-blog-search-input]');
      this.results = this.querySelector('[data-blog-search-results]');
      this.status = this.querySelector('[data-blog-search-status]');
      this.list = this.querySelector('[data-blog-search-list]');
      if (!this.input || !this.results) return;

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.timer);
        const query = this.input.value.trim();
        if (query.length < 2) {
          this.close();
          return;
        }
        this.timer = window.setTimeout(() => this.search(query), 220);
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    setState(message, state) {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.status.textContent = message;
      this.status.dataset.state = state;
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.list.replaceChildren();
    }

    async search(query) {
      this.controller?.abort();
      this.controller = new AbortController();
      this.list.replaceChildren();
      this.setState('Searching the guide library…', 'loading');

      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'article',
          'resources[limit]': '8'
        });
        const response = await fetch(`/search/suggest.json?${params.toString()}`, {
          headers: { Accept: 'application/json' },
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error('Search is temporarily unavailable.');
        const payload = await response.json();
        const articles = payload?.resources?.results?.articles || [];

        if (!articles.length) {
          this.setState(`No guides found for “${query}”. Try a broader term.`, 'empty');
          return;
        }

        this.status.textContent = `${articles.length} ${articles.length === 1 ? 'guide' : 'guides'} found.`;
        this.status.dataset.state = 'success';
        const fragment = document.createDocumentFragment();
        articles.forEach((article) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = article.url;
          link.textContent = article.title;
          item.appendChild(link);
          fragment.appendChild(item);
        });
        this.list.replaceChildren(fragment);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.setState('Search could not be completed. Press Search to view full results.', 'error');
      }
    }
  }

  customElements.define('blog-article-search', BlogArticleSearch);
}
